module.exports = __webpack_public_path__ + "img/danwei_sl_icon@2x.c4b410ed.png";